import React, { useState } from "react";
import clsx from "clsx";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead.bs5.css";
import "./google-auto-complete.scss";

interface SuggestedArea {
    description: string;
    [key: string]: any;
}

interface GoogleAutoCompleteProps {
    onChange?: (event: any) => void;
    inputValue?: string;
    suggestedAreas: SuggestedArea[];
    onSelect?: (data: SuggestedArea, isEnterKey?: boolean) => void;
    wrapperClassName?: string;
    placeholder?: string;
    isLoading?: boolean;
}

const GoogleAutoComplete: React.FC<GoogleAutoCompleteProps> = ({
    onChange = () => {},
    inputValue = "",
    suggestedAreas,
    onSelect = () => {},
    wrapperClassName,
    placeholder,
    isLoading = false,
}) => {
    const [dirty, setDirty] = useState<boolean>(false);
    const [firstChange, setFirstChange] = useState<boolean>(true);
    const selected = suggestedAreas.filter((s) => s.description === inputValue);

    return (
        <div className={clsx("google-form-control", wrapperClassName ?? "")}>
            <Typeahead
                id="select-location-input"
                onChange={(data: any[]) => {
                    onSelect(data[0] as SuggestedArea);
                }}
                onInputChange={(data: string, event: any) => {
                    onChange(event);
                    setDirty(true);
                    if (firstChange) {
                        setTimeout(() => {
                            setFirstChange(false);
                        }, 500);
                    }
                }}
                onKeyDown={(e: React.KeyboardEvent) => {
                    if (e.key === "Enter" && suggestedAreas[0]) {
                        onSelect(suggestedAreas[0], true);
                    }
                }}
                options={suggestedAreas}
                placeholder={placeholder}
                selected={selected}
                labelKey="description"
                disabled={isLoading}
                clearButton={!isLoading}
                renderMenu={(results: any[], menuProps: any, state: any) => {
                    if (!dirty || isLoading || !inputValue.length) {
                        return null;
                    }

                    // For overriding the bug for Menu position on initial display
                    if (firstChange) {
                        return (
                            <Menu {...menuProps}>
                                <MenuItem option="" position={0} disabled>
                                    No matches found.
                                </MenuItem>
                            </Menu>
                        );
                    }

                    return (
                        <Menu {...menuProps}>
                            {results.map((result, index) => (
                                <MenuItem option={result} position={index} key={index}>
                                    {result.description}
                                </MenuItem>
                            ))}
                        </Menu>
                    );
                }}
            />
        </div>
    );
};

export default GoogleAutoComplete;
